import type { FC } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import {
    StyledEnrichmentButtonWrapper,
    StyledEnrichmentErrorDescription,
    StyledEnrichmentErrorIcon,
    StyledEnrichmentErrorTitle,
    StyledEnrichmentErrorWrapper,
} from "./styles";

type EnrichmentErrorProps = {
    onClose: () => void;
    errorText?: string;
};
const EnrichmentError: FC<EnrichmentErrorProps> = ({ onClose, errorText }) => {
    const { translate } = useTranslate();

    return (
        <StyledEnrichmentErrorWrapper>
            <StyledEnrichmentErrorIcon>
                <SWReactIcons iconName={"error-state"} />
            </StyledEnrichmentErrorIcon>
            <StyledEnrichmentErrorTitle>{errorText}</StyledEnrichmentErrorTitle>
            <I18n
                translatable={{ key: "si.common.error.contact-support" }}
                element={StyledEnrichmentErrorDescription}
            />
            <StyledEnrichmentButtonWrapper>
                <Button
                    type={"flat"}
                    onClick={onClose}
                >
                    {translate("si.common.got-it")}
                </Button>
            </StyledEnrichmentButtonWrapper>
        </StyledEnrichmentErrorWrapper>
    );
};

export default EnrichmentError;
